import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import vueScroll from "vuescroll";
import { getUserCatalog } from "@/api/course";

@Component({
    components: {
        vueScroll
    }
})
export default class ChapterList extends Vue {
    private chapterName: string = "";
    private courseId: number | undefined;
    private ops: any = {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "rgba(0, 0, 0, 0.4)"
        }
    };
    private currentChapter: any = {};
    @Prop() readonly currentModule: any;
    mounted() {
        this.courseId = Number(this.$route.params.courseId);
    }
    @Watch("currentModule")
    getCurrentChapter(currentModule) {
        this.chapterName = currentModule.moduleName.split("：")[1];
        currentModule.children.forEach(chapterItem => {
            if (chapterItem.status === "LEARNING" && !chapterItem.placeStatus) {
                this.currentChapter = chapterItem;
            }
            if (chapterItem.placeStatus) {
                this.currentChapter = chapterItem;
            }
            localStorage.setItem(
                "sectionItemId" + this.courseId,
                this.currentChapter.children[0].children[0].id
            );
        });
    }
    handleCurrentChapterClick(chapterItem) {
        this.currentChapter = chapterItem;
        if (this.currentChapter.status !== "UNLEARNED") {
            localStorage.setItem(
                "sectionItemId" + this.courseId,
                this.currentChapter.children[0].children[0].id
            );
        } else {
            this.$message.warning("你还未学到此小节，请按顺序学习");
        }
    }
    handleToStudyClick() {
        this.fetchUserCatalog(this.courseId);
    }
    fetchUserCatalog(courseId) {
        getUserCatalog(courseId).then(res => {
            //@ts-ignore
            if (res.code === 200) {
                this.$router.push("/middleStudy/" + courseId);
                //@ts-ignore
            } else if (res.code === 2025) {
                this.$message.warning("课程过期");
                //@ts-ignore
            } else if (res.code === 2026) {
                this.$message.warning("课程未开课");
            }
        });
    }
}
//@ts-ignore
export { default as ChapterList } from "./index.vue";
